import React, { useState } from 'react';
import { supabase } from '../../utils/supabase';
import { GCP_BACKEND_URL } from '../../types';
import { AuthFormProps } from './types';
import './styles.scss';

const SignupForm: React.FC<AuthFormProps> = ({ setAuthView }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    try {
      const { error } = await supabase.auth.signUp({ email, password });
      if (error) throw error;

      // Send welcome email
      try {
        const formData = new FormData();
        formData.append('user_email', email);
        formData.append('credits', '20');

        await fetch(`${GCP_BACKEND_URL}/api/email/welcome`, {
          method: 'POST',
          body: formData
        });
      } catch (emailErr) {
        console.error('Failed to send welcome email:', emailErr);
        // Don't block signup if email fails
      }

      setSuccess(true);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="success-screen">
        <div className="success-icon">✓</div>
        <h2>Check Your Email!</h2>
        <p>We've sent you a verification link.</p>
        <button onClick={() => setAuthView('login')} className="btn btn-primary">
          Back to Login
        </button>
      </div>
    );
  }

  return (
    <div className="auth-form">
      <h2>Create Account</h2>
      <p className="auth-subtitle">Start analyzing satellite imagery</p>

      {error && <div className="error-message">{error}</div>}

      <div className="form-content">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="form-input"
          required
        />
        <input
          type="password"
          placeholder="Password (min 6 characters)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="form-input"
          required
          minLength={6}
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="form-input"
          required
        />
        <button onClick={handleSubmit} disabled={loading} className="btn btn-primary btn-large">
          {loading ? 'Creating account...' : 'Sign Up'}
        </button>
        <div className="form-links">
          Already have an account?{' '}
          <button onClick={() => setAuthView('login')} className="link-button">
            Sign in
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
